import { useCallback, useEffect } from 'react'
import PaymentMainSection from '../../PaymentMainSection'
import usePaymentContext from '../../hook/usePaymentContext'
import useSplitPaymentContext from './SplitPaymentContext'
import { PAYMENT_TYPE_ID } from 'constant/paymentType'
import { PaymentIntegrationProcessStatus } from '../../Models/Enum'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import { PaymentMainSectionMobile } from '../../PaymentMainSectionMobile'
export function ChargingDialog() {
    const {
        onSubmitPayment,
        payment,
        paymentIntegrationProcessStatus,
        paymentIntegrationPaymentID,
        resetEvoPaymentDialogState,
    } = usePaymentContext()

    const { onFinishCharging, onClickBack } = useSplitPaymentContext()
    const onSubmitPaymentSplit = useCallback(async () => {
        const paymentID = await onSubmitPayment()
        if (payment?.paymentTypeID !== PAYMENT_TYPE_ID.EVO_PAYMENT) {
            onFinishCharging(paymentID)
        }
    }, [onSubmitPayment, onFinishCharging, payment?.paymentTypeID])

    useEffect(() => {
        if (
            paymentIntegrationProcessStatus ===
                PaymentIntegrationProcessStatus.SUCCESS &&
            paymentIntegrationPaymentID
        ) {
            onFinishCharging(paymentIntegrationPaymentID)

            //Then clear state about Evo
            if (resetEvoPaymentDialogState) resetEvoPaymentDialogState()
        }
    }, [
        paymentIntegrationProcessStatus,
        onFinishCharging,
        paymentIntegrationPaymentID,
        resetEvoPaymentDialogState,
        payment?.paymentTypeID,
    ])
    const { isMobile } = useScreenSize()
    if (isMobile)
        return (
            <PaymentMainSectionMobile
                onBack={onClickBack}
                onSubmitPayment={onSubmitPaymentSplit}
            />
        )
    return (
        <PaymentMainSection
            isSplitPayment
            onSubmitPayment={onSubmitPaymentSplit}
        />
    )
}
